import { render, staticRenderFns } from "./SectionNosotros1.vue?vue&type=template&id=d57ef314&scoped=true&"
import script from "./SectionNosotros1.vue?vue&type=script&lang=js&"
export * from "./SectionNosotros1.vue?vue&type=script&lang=js&"
import style0 from "./SectionNosotros1.vue?vue&type=style&index=0&id=d57ef314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57ef314",
  null
  
)

export default component.exports